// src/pages/Collections.jsx
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PublicAPI } from '../api/public';
import { useAppStore } from '../store/useAppStore';
import { normalizeMediaUrl } from '../api/base';
import { renderTextWithLineBreaks } from '../utils/textHelpers';

const Page = styled.main`padding:18px 0;`;
const H1 = styled.h1`margin:0 0 12px;`;
const Sub = styled.p`margin:-6px 0 18px; opacity:.8;`;

const Grid = styled.div`
  display:grid; gap:16px; grid-template-columns: repeat(3, 1fr);
  @media (max-width:980px){ grid-template-columns: repeat(2, 1fr); }
  @media (max-width:640px){ grid-template-columns: 1fr; }
`;

const Card = styled(Link)`
  display:block; background: var(--card); border:1px solid var(--bdr);
  border-radius:16px; overflow:hidden; box-shadow: var(--shadow);
  img{ height:170px; width:100%; object-fit:cover; display:block; }
  h4{ margin:10px 12px 6px; font-size:16px; }
  p{ margin:0 12px 12px; opacity:.8; font-size:14px; }
`;

export default function CollectionsPage(){
  const { t, i18n } = useTranslation();
  const regionSlug = useAppStore(s => s.regionSlug);
  const [items, setItems] = React.useState([]);
  const [err, setErr] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  React.useEffect(()=>{
    let cancelled = false;
    (async ()=>{
      setLoading(true); setErr('');
      try{
        const res = await PublicAPI.collections({ locale: i18n.language || 'ru', page_size: 100, region: regionSlug || undefined });
        if (!cancelled) setItems(Array.isArray(res?.items) ? res.items : []);
      }catch(e){ if(!cancelled) setErr(e.message || 'Error'); }
      finally{ if(!cancelled) setLoading(false); }
    })();
    return ()=>{ cancelled = true; };
  }, [i18n.language, regionSlug]);

  return (
    <Page>
      <div className="container">
        <H1>{t('collections.title', 'Подборки объектов')}</H1>
        <Sub>{t('collections.subtitle', 'Готовые наборы для быстрого выбора')}</Sub>

        {err && <div style={{color:'#c62828', marginBottom:8}}>{err}</div>}
        {loading && <div style={{opacity:.7}}>Загрузка…</div>}

        {!loading && !items.length ? (
          <p>{t('collections.empty','Пока нет подборок')}</p>
        ) : (
          <Grid>
            {items.map((c,i)=>(
              <Card key={c.id ?? i} to={`/collections/${encodeURIComponent(c.slug)}`}>
                { (c.cover || c.cover_url || c.cover_thumb) && (
                  <img src={normalizeMediaUrl(c.cover || c.cover_url || c.cover_thumb)} alt={c.title} loading="lazy" decoding="async" />
                )}
                <h4>{c.title}</h4>
                {c.description && (
                  <div dangerouslySetInnerHTML={renderTextWithLineBreaks(c.description, true)} />
                )}
              </Card>
            ))}
          </Grid>
        )}
      </div>
    </Page>
  );
}
